<template>
    <main class="login-form">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-sm-8 col-sm-pull-4 main-center">
                    <b-alert class="display-5" show>Αν αντιμετωπίσετε κάποιο πρόβλημα κατά την είσοδο, παρακαλούμε να συνδεθείτε μέσω ανώνυμης περιήγησης.</b-alert>
                   <b-alert class="dis-flex" variant="danger" v-if="isBannerVisible" show>
                     <b-icon-exclamation-triangle-fill scale="1.5"></b-icon-exclamation-triangle-fill>
                     <p class="text-justify">Σας ενημερώνουμε ότι λόγω προγραμματισμένων εργασιών αναβάθμισης των υποδομών
                       της Γενικής Γραμματείας Πληροφοριακών Συστημάτων Δημόσιας Διοίκησης (Γ.Γ.Π.Σ.Δ.Δ.) του Υπουργείου
                       Ψηφιακής Διακυβέρνησης, κατά το χρονικό διάστημα από Παρασκευή 20 Μαΐου 2022 και ώρα 23:00 έως
                       και Σάββατο 21 Μαΐου 2022 και ώρα 9:00 δεν θα είναι διαθέσιμη η ταυτοποίηση μέσω TaxisNet.
                       (για να δείτε τη σχετική ανακοίνωση πατήστε
                       <a href="https://www.gsis.gr/Downtime_Exadata.Cloud">εδώ</a>)</p>
                   </b-alert>
                    <div class="card">
                        <div class="card-header">
                            <h3 style="margin: 0">Πληροφορίες</h3>
                        </div>
                        <div class="card-body text-justify">
                            <p>Η Δνση Επιστράτευσης-Εθνοφυλακής του Γενικού Επιτελείου Στρατού (ΓΕΣ/Α4) σας καλωσορίζει στη νέα της διαδικτυακή εφαρμογή, μέσω της οποίας επιτυγχάνεται:</p>
                            <ol>
                                <li>Η επικαιροποίηση των ατομικών στοιχείων των εφέδρων από τους ιδίους.</li>
                                <li>Η δυνατότητα πληροφόρησης στοχευμένων ομάδων εφέδρων περί αδιαβάθμητων ανακοινώσεων, οι οποίες θα αναρτώνται από το ΓΕΣ/Α4 (ΔΕΠΕΘ) και τις Επιστρατεύουσες Αρχές (Ε.Α.). Οι εν λόγω ανακοινώσεις θα αποστέλλονται ταυτόχρονα στα ηλεκτρονικά γραμματοκιβώτια (e-mails) των εφέδρων με την μορφή προσωπικής πληροφόρησης (newsletters).</li>
                                <li>Η αποστολή μηνυμάτων από τον έφεδρο στην Μονάδα που τον παρακολουθεί.</li>
                            </ol>
                        </div>
                        <!-- <div class="card-header">
                            <h3 style="margin: 0">Οδηγίες Εισόδου στο Σύστημα</h3>
                        </div>
                        <div class="card-body text-justify">
                                <p>Για την είσοδό σας στην εφαρμογή απαιτείται να πληκτρολογήσετε το όνομα χρήστη (username) και τον κωδικό πρόσβασης (password) που δηλώσατε κατά την εγγραφή σας</p>
                                <p>Σε περίπτωση που δεν είστε εγγεγραμμένος χρήστης πατήστε το σύνδεσμο <router-link to="/validate">Εγγραφή Νέου Χρήστη</router-link></p>
                                <p>Δείτε αναλυτικά <a data-placement="bottom" title="Οδηγίες" target="_blank" href="/files/efedros user manual.pdf">εδώ</a> τις οδηγίες εγγραφής και χρήσης της εφαρμογής.</p>
                        </div> -->
                    </div>
                    <div class="card">
                        <img class="card-img-top" src="/files/efedrosHomeImage.jpg" alt="Card image cap">
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4 col-sm-push-8 main-center">
                    <div class="card">
                        <div class="card-header">
                            <h3>Σύνδεση μέσω Taxisnet</h3>
                        </div>
                        <div class="card-body">
                            <form :action="appUrl + 'api/auth/login'" class="custom-login-form" method="GET">
                                <b-button type="submit" variant="primary">
                                    Είσοδος Εφέδρων <b-icon-lock-fill></b-icon-lock-fill>
                                </b-button>
                            </form>
                            <br>
                            <form :action="appUrl + 'api/auth/logingov'" class="custom-login-form" method="GET">
                              <b-button type="submit" variant="warning">
                                Είσοδος Διαχειριστών με Κωδικούς Δημοσίων Υπαλλήλων <b-icon-lock-fill></b-icon-lock-fill>
                              </b-button>
                            </form>
                        </div>
                        <Message v-if="notAdmin" msgClass="danger" message="Δεν διαθέτετε καθήκοντα διαχειριστή στην εφαρμογή"></Message>
                        <Message v-if="notVerified" msgClass="danger" message="Ο λογαριασμός σας βρίσκεται υπό έλεγχο"></Message>
                        <Message v-if="blocked" msgClass="danger" message="Ο λογαριασμός σας είναι αποκλεισμένος"></Message>
                        <Message v-if="sessionExpired" msgClass="danger" message="Η συνεδρία σας έληξε. Παρακαλώ συνδεθείτε εκ νέου."></Message>
                    </div>
                    <div class="card mt-5">
                        <div class="card-header">
                            <h3 style="margin: 0">Στοιχεία Επικοινωνίας και Υποστήριξης</h3>
                        </div>
                        <div class="card-body text-justify">
                            <p>Δνση Επιστράτευσης-Εθνοφυλακής: (ΓΕΣ/Α4)</p>
                            <p>Ιστότοπος: epistrateusi.army.gr</p>
                            <p>E-Mail: str-ges-depeth [ΑΤ] army.gr</p>
                            <p>Για υποστήριξη/ερωτήσεις σχετικά με την εφαρμογή</p>
                            <p>E-Mail: des-mo [ΑΤ] army.gr</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import {Structs} from '../structs.js'
    import Message from '../components/Message.vue'

    export default {
        name: "Login",
        components:{
            Message
        },
        data(){
            return {
                credentials:Structs.Credentials(),
                message:'',
                msgVisible:false,
                msgClass:'',
                disableButton: false,
                currentDate: new Date(),
                bannerDateDeadline: {
                  startDate: new Date("Fri May 20 2022 23:00:00 GMT+0300"),
                  endDate: new Date("Sat May 21 2022 09:00:00 GMT+0300")
                }
            }
        },
        computed: {
            isDisable: function() {
                return this.disableButton;
            },
            appUrl() {
                return process.env.VUE_APP_API_URL
            },
            notAdmin() {
              return this.$store.state.notAdmin
            },
            notVerified() {
                return this.$route.query.notVerified
            },
            blocked() {
                return this.$route.query.blocked
            },
            sessionExpired() {
              return this.$route.query.sessionExpired
            },
            isBannerVisible() {
              return this.currentDate >= this.bannerDateDeadline.startDate && this.currentDate <= this.bannerDateDeadline.endDate
            },
        },
        mounted() {
            if (this.$store.getters.isLoggedIn) this.$router.push('home');
            // this.$nextTick(grecaptcha.ready(this.renderCaptcha));
        },
        methods : {

            clearMsgBox(){
                this.message = '';
                this.msgVisible = false;
                this.msgClass = '';
            },

            setMsg(status,msg){
                this.message = msg;
                this.msgClass = status;
                this.msgVisible = true;
            },

            // verifyCaptcha: function () {
            //     document.getElementById('g-recaptcha-error').innerHTML = '';
            // },

            // renderCaptcha: function () {
            //     grecaptcha.render('g-recaptcha', {
            //         'sitekey' : '6Lep3bgUAAAAAIWxoYkjCBlAzFwLaZFgX1AHbZzc',
            //         'callback': this.verifyCaptcha(),
            //         'theme' : 'light'
            //     });
            //     this.disableButton = false;
            // },

            login: function () {
                this.clearMsgBox();
                if (this.credentials.username.length === 0 || this.credentials.password.length === 0) {
                    this.setMsg('danger','Πρέπει όλα τα πεδία να είναι συμπληρωμένα!');
                    return;
                }
                if(this.$validator.containSpecialChars(this.credentials.username) || this.$validator.containSpecialChars(this.credentials.password)) {
                    this.setMsg('danger','Απαγορεύονται οι ειδικοί χαρακτήρες. Παρακαλούμε δοκιμάστε εκ νέου.');
                    return;
                }
                    // eslint-disable-next-line no-undef
                let response = grecaptcha.getResponse();

                if(response.length == 0)
                {
                    document.getElementById('g-recaptcha-error').innerHTML = '' +
                        '<span style="color:red;">Η επίλυση του captcha είναι απαραίτητη.</span>';
                    return;
                }

                let that = this;

                this.$store.dispatch('loading');
                this.$store.dispatch('login', this.credentials)
                .then(r => {
                    if(r.data.message){
                        this.setMsg('warning',r.data.message);
                        return;
                    }
                    that.$router.push('home');

                })
                .catch(e => {
                    var resp = e.response;
                    this.setMsg('danger',(resp.data.errorMessage)? resp.data.errorMessage : resp.statusText);
                })
                .finally(() => this.$store.dispatch('stop_loading'));
            }
        }
    }
</script>

<style lang="scss">

</style>